const TurnoService = {
  validarFecha(fechaDesde, fechaHasta, fechaNacimiento) {
    if(fechaDesde === null && fechaHasta === null){
      return true
    }else if (fechaNacimiento) {
      let fechaInicial = new Date(fechaDesde)
      let fechaFinal = new Date(fechaHasta)
      let fechaNac = new Date(fechaNacimiento)

      return fechaNac >= fechaInicial && fechaNac <= fechaFinal
    } else {
      return false
    }
  },

  validarSexo(filtroSexo, sexoPaciente) {
    if (!filtroSexo) {
      return true
    } else if (!sexoPaciente) {
      return false
    }else {
      return filtroSexo === sexoPaciente
    }
  },

  matchTurnoPaciente(turno, paciente) {
    return this.validarSexo(turno.filtroSexo, paciente.sexo) && this.validarFecha(turno.filtroFechaNacimientoDesde, turno.filtroFechaNacimientoHasta, paciente.fechaNacimiento)
  }
}

export default TurnoService